import routeFinderImage from "../assets/projects/route-finder.svg";
import examSystemImage from "../assets/projects/exam-system.svg";
import microservicesImage from "../assets/projects/microservices.svg";
import mobicomMobileImage from "../assets/projects/mobicom-mobile.svg";

export const navItems = [
  { label: "Нүүр", href: "home" },
  { label: "Миний тухай", href: "about" },
  { label: "Чадварууд", href: "skills" },
  { label: "Төслүүд", href: "projects" },
  { label: "Боловсрол", href: "education" },
  { label: "Холбоо барих", href: "contact" },
];

export const roles = [
  "Full Stack Developer",
  "Backend Developer",
  "React Developer",
  "Spring Boot Developer",
  "Data Analysis Learner",
];

export const stats = [
  { value: "2023", label: "оноос суралцаж байна" },
  { value: "3-р", label: "курс" },
  { value: "10+", label: "технологи" },
  { value: "5+", label: "төсөл" },
  { value: "3.4", label: "GPA" },
];

export const skillCategories = [
  {
    title: "Frontend",
    status: "Used in projects",
    skills: ["HTML/CSS", "JavaScript", "TypeScript", "React", "React Native", "Tailwind CSS"],
  },
  {
    title: "Backend",
    status: "Used in projects",
    skills: [
      "Java",
      "Spring Boot",
      "REST API",
      "Microservice Architecture",
      "Eureka Server/Client",
      "Service Discovery",
      "Load Balancing",
    ],
  },
  {
    title: "Programming",
    status: "Comfortable",
    skills: ["Python", "C#", "C++", "Java"],
  },
  {
    title: "Database / Tools",
    status: "Used in projects",
    skills: ["Docker", "MongoDB", "Git", "GitHub", "Postman", "Swagger"],
  },
  {
    title: "Data / Analysis",
    status: "Learning",
    skills: ["Data Analysis", "Algorithm Analysis", "Problem Solving", "Documentation"],
  },
  {
    title: "Soft Skills",
    status: "Comfortable",
    skills: [
      "Багаар ажиллах",
      "Цагийн менежмент",
      "Дасан зохицох",
      "Харилцааны чадвар",
      "Ажлын ачаалал даах",
      "Нягт нямбай",
    ],
  },
];

export const projects = [
  {
    title: "Dijkstra, BFS, DFS Route Finder",
    desc: "Dijkstra, BFS, DFS алгоритмуудыг харьцуулан Улаанбаатар хотын замын хамгийн оновчтой чиглэл олох систем боловсруулсан.",
    tags: ["Python", "Algorithms", "Graph Theory", "Data Structures"],
    accent: "from-cyan-400 to-blue-500",
    image: routeFinderImage,
    imageAlt: "Dijkstra, BFS, DFS route finder visualization",
    links: [
      { label: "Python Repo", href: "https://github.com/Nurlan11232/AlgorithmBD-Python.git" },
      { label: "Java Repo", href: "https://github.com/Nurlan11232/AlgorithmBD-Java.git" },
    ],
  },
  {
    title: "School Exam Web System",
    desc: "API ашигласан сургуулийн шалгалтын web system хөгжүүлж, UI/UX design болон frontend хэсэг дээр ажилласан.",
    tags: ["React", "JavaScript", "REST API", "UI/UX", "Docker", "MongoDB"],
    accent: "from-blue-400 to-purple-500",
    image: examSystemImage,
    imageAlt: "School exam web system dashboard preview",
    links: [{ label: "GitLab Repo", href: "https://gitlab.com/B231910026/web-bie-daalt" }],
  },
  {
    title: "Microservice Architecture Project",
    desc: "Spring Boot ашиглан microservice architecture дээр ажиллаж, Eureka Server/Client, Service Discovery, Load Balancing зэрэг ойлголтуудыг хэрэгжүүлсэн.",
    tags: ["Java", "Spring Boot", "Microservices", "Eureka", "Docker", "REST API"],
    accent: "from-purple-400 to-fuchsia-500",
    image: microservicesImage,
    imageAlt: "Spring Boot microservice architecture diagram",
    links: [{ label: "GitLab Repo", href: "https://gitlab.com/B231910026/cloud-computing" }],
  },
  {
    title: "Mobicom Mobile Application",
    desc: "Mobile application development төслийн хүрээнд Mobicom аппликэйшний UI болон app development хэсэг дээр ажилласан.",
    tags: ["React Native", "Mobile App", "UI/UX Design"],
    accent: "from-cyan-400 to-purple-500",
    image: mobicomMobileImage,
    imageAlt: "Mobile application UI concept preview",
    links: [{ label: "GitHub Repo", href: "https://github.com/Nurlan11232/MobileProgrammchlal2025" }],
  },
];

export const coursework = [
  "Обьект хандалтат програмчлал",
  "Өгөгдлийн бүтэц ба алгоритм",
  "Frontend болон Backend хөгжүүлэлт",
  "Микросервис архитектур",
  "UI/UX дизайн",
  "Гар утасны аппликэйшн хөгжүүлэлт",
  "Data Analysis",
];

export const contactLinks = [
  { label: "Email", text: "nurlannurka245@gmail.com", href: "mailto:nurlannurka245@gmail.com" },
  { label: "Phone", text: "85310060, 66919635", href: "tel:85310060" },
  { label: "Location", text: "Ulaanbaatar, Mongolia", href: "https://maps.google.com/?q=Ulaanbaatar%20Mongolia" },
  { label: "GitHub", text: "github.com/Nurlan11232", href: "https://github.com/Nurlan11232" },
];
